import LoadingTextBlock from '@/atoms/Skeletons/LoadingTextBlock';
import CustomMarkdown from '@/molecules/CustomMarkdown';
import WidgetCTA from 'components/widgets/components/WidgetCTA';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import { useTranslation } from 'react-i18next';
import { useCMSmodals } from 'utils/cms';

type Props = {
  closeModal: () => void;
  cmsModalName:
    | 'printing-existing-draft-order-warning'
    | 'printing-order-delete-card-from-pack'
    | 'printing-order-delete-pack'
    | 'printing-order-delete'
    | 'printing-order-onboarding'
    | 'printing-order-warning-finish-pack'
    | 'printing-slot-information'
    | 'wallet-buy-insufficient-balance'
    | 'wallet-eligibility'
    | 'sell-cards-reach-antifraud-limits'
    | 'wallet-printing-credit-information';
  onSubmit?: () => void;
};

const CMSModal = ({ closeModal, cmsModalName, onSubmit }: Props) => {
  const { t } = useTranslation();
  const {
    queryResult: { data, isLoading },
  } = useCMSmodals({ cmsModalName });

  const onSubmitCallback = onSubmit || closeModal;

  return (
    <ModalClassicLayout
      closeModal={closeModal}
      isLoadingContent={isLoading}
      onSubmit={!data?.ctas ? onSubmitCallback : undefined}
      title={isLoading ? t('loading') : data?.displayTitle}
    >
      {isLoading ? (
        <LoadingTextBlock />
      ) : (
        <div className="flex flex-col gap-4">
          {/* TODO This should use the same system as CMS pages with templates */}
          <CustomMarkdown>{data?.displayText || ''}</CustomMarkdown>
          {data?.foreground?.image && (
            <img
              alt={data?.foreground?.image.alt}
              className="m-auto"
              height={Number(data?.foreground?.image.sizes['medium-height'])}
              src={data?.foreground?.image.sizes.large}
              width={Number(data?.foreground?.image.sizes['medium-width'])}
            />
          )}
          {data?.ctas &&
            data?.ctas?.map((cta) => (
              <WidgetCTA
                key={cta.link?.url}
                cta={cta}
                onClick={cta.link?.url === '#' ? onSubmitCallback : undefined}
                widgetId="cta"
              />
            ))}
        </div>
      )}
    </ModalClassicLayout>
  );
};

export default CMSModal;
